import { RootState } from '@reducers';

export const selectFeatureUser = (state: RootState) => state.featureReducer.userReducer;
